module.exports = __webpack_public_path__ + "static/service5-140633a8ba2a8d0f49b4b8e5fb98705c.png";